import { gql } from "@apollo/client";

export const GET_VISITAS = gql`
query visitas($input: GetVisitasFiltersInput!) {
  visitas(input: $input) 
  {
    idVisita
    idEvaluacion
    idEvaluacionNavigation{
      idPaciente
      idTipoModulo
      idTipoModuloNavigation{
        abreviacion
      }
      idPacienteNavigation{
        nombre
        apellido
      }
    }
    idComboVisitaValorTipoVisitaNavigation {
      idComboVisitaValor
      valor
    }
    direccion
    posX
    posY
    idFrecuencia
    idUsuarioCreador
    idTipoProfesional
    idProfesional
    idEstado
    idEstadoNavigation {
      descripcion
    }
    fechaVisita
    tiempoEspera
    explicacion
    idProfesionalNavigation {
      idFuncion
    }
  }
}`;

export const parseVisitas = (visitas) =>
structuredClone(visitas).map((visit) => ({
  ...visit,
  tipoVisita: visit.idComboVisitaValorTipoVisitaNavigation?.valor,
  idTipoVisita: visit.idComboVisitaValorTipoVisitaNavigation?.idComboVisitaValor,
  estado: visit.idEstadoNavigation?.descripcion,
  idPaciente: visit.idEvaluacionNavigation?.idPaciente,
  idTipoModulo: visit.idEvaluacionNavigation?.idTipoModulo,
  programa: visit.idEvaluacionNavigation?.idTipoModuloNavigation?.abreviacion,
  idProfesionalNavigation: visit.idProfesionalNavigation,
  paciente: visit.idEvaluacionNavigation?.idPacienteNavigation ?
  `${visit.idEvaluacionNavigation.idPacienteNavigation.nombre} ${visit.idEvaluacionNavigation.idPacienteNavigation.apellido}` :
  ''
}));